const coursetypegroups = {
	title: "Kompetanseområder",
	stitle: "Kompetanseområde",
	new_coursetypegroup: "Ny kompetanseområde",
	edit_coursetypegroup: "Rediger: {name} ",
	view_coursetypegroup: "Vis: {name}",
	list_title: "Kompetanseområder",
	list_subtitle: "Håndtere kompetanseområder",
	create_title: "Opprett kompetanseområde",
	update_title: "Endre kompetanseområde",
	details_title: "Kompetanseområder detaljer",
	id: "ID",
	name: "Navn",
	category: "Gruppekode",
	status: "Status",
	type: "Type",
	available_to_all: "Etterregistrert/digitalisert kompetanse",
	coursetype_mandatory: "Obligatorisk kompetanse valg",
};
export default coursetypegroups;